import React, { useState } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function BottomTab({ title, count, onPageChange, pageSize = 20 }: any) {
  
  const roundedNumber = Math.ceil(count / pageSize);

  const totalNumberOfPages = roundedNumber;
  const maxVisibleButtons = 4;
  const [activePage, setActivePage] = useState(1);

  const handlePrevPage = () => {
    if (activePage > 1) {
      setActivePage((prevPage) => prevPage - 1);
      onPageChange(activePage - 1);
    }
  };

  const handleNextPage = () => {
    if (activePage < totalNumberOfPages) {
      setActivePage((prevPage) => prevPage + 1);
      onPageChange(activePage + 1);
    }
  };

  const handlePageClick = (page: any) => {
    setActivePage(page);
    if (onPageChange) {
      onPageChange(page);
    }
  };

  const getPageButtons = () => {
    const buttons = [];

    let startPage = Math.max(1, activePage - Math.floor(maxVisibleButtons / 2));
    let endPage = Math.min(totalNumberOfPages, startPage + maxVisibleButtons - 1);

    if (endPage - startPage + 1 < maxVisibleButtons) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    if (startPage > 1) {
      buttons.push(
        <button
          key={1}
          onClick={() => handlePageClick(1)}
          className="w-8 h-8 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(
          <span key="ellipsis-start" className="w-8 h-8 flex items-center justify-center text-slate-400 dark:text-slate-500">
            ...
          </span>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`w-8 h-8 rounded-lg text-sm font-medium transition-all ${
            activePage === i
              ? "bg-primary text-white shadow-md shadow-primary/20"
              : "text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700"
          }`}
        >
          {i}
        </button>
      );
    }

    if (endPage < totalNumberOfPages) {
      if (endPage < totalNumberOfPages - 1) {
        buttons.push(
          <span key="ellipsis-end" className="w-8 h-8 flex items-center justify-center text-slate-400 dark:text-slate-500">
            ...
          </span>
        );
      }
      buttons.push(
        <button
          key={totalNumberOfPages}
          onClick={() => handlePageClick(totalNumberOfPages)}
          className="w-8 h-8 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
        >
          {totalNumberOfPages}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-slate-50/50 dark:bg-slate-800/50">
      <span className="text-sm text-slate-600 dark:text-slate-400">
        <span className="font-semibold text-slate-800 dark:text-slate-200">{count}</span> {title ?? "items"}
      </span>
      <div className="flex items-center gap-1">
        <button
          onClick={handlePrevPage}
          disabled={activePage === 1}
          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${
            activePage === 1
              ? "text-slate-300 dark:text-slate-600 cursor-not-allowed"
              : "text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700"
          }`}
          aria-label="Previous page"
        >
          <ChevronLeftIcon sx={{ fontSize: 20 }} />
        </button>
        {getPageButtons()}
        <button
          onClick={handleNextPage}
          disabled={activePage === totalNumberOfPages || totalNumberOfPages === 0}
          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${
            activePage === totalNumberOfPages || totalNumberOfPages === 0
              ? "text-slate-300 dark:text-slate-600 cursor-not-allowed"
              : "text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700"
          }`}
          aria-label="Next page"
        >
          <ChevronRightIcon sx={{ fontSize: 20 }} />
        </button>
      </div>
    </div>
  );
}

export default BottomTab;
